const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/weekly-educational-topics",
  },
  actions: {
    // Filial va akademik yil kesimidagi haftalar ro'yxati
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/?${serialize(options)}`, method: "GET", data: {} }, { root: true });
      }
    },
    // Hafta mavzularini saqlash (saqlangan hafta tasdiqlangan hisoblanadi)
    save({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/save`, method: "POST", data }, { root: true });
      }
    },
    // Avtomat nusxalangan mavzularni o'zgartirmasdan tasdiqlash
    confirm({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/confirm`, method: "POST", data }, { root: true });
      }
    },
    // Ota-onalarga kunlik yuborish sozlamasini olish
    getParentsSendSettings({ dispatch, state, rootState }) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/parents-send-settings`, method: "GET", data: {} }, { root: true });
      }
    },
    // Sozlamani saqlash (faqat rahbar)
    saveParentsSendSettings({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch("FETCH", { url: `${state.path}/parents-send-settings`, method: "POST", data }, { root: true });
      }
    },
  },
};
